// This file should include all tests running in the form of
// export const [TEST_NAME] = [TEST_NUMBER]
export const experimentsEnum = {
    CAT_LISTINGS_SEARCH_BAR_CHANGE_HIGHLIGHT_TEXT: 2396
};
